import React from "react";

import { SS23 } from "../../../../js/database/database-ss23.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const GatheredSleeveShirtRedBrown = () => {
  return (
    <ProductsContainer
      pageTitle={SS23.tops.GatheredSleeveShirtRedBrown.itemName}
      name={SS23.tops.GatheredSleeveShirtRedBrown.itemName}
      price={SS23.tops.GatheredSleeveShirtRedBrown.itemPrice}
      fabric={SS23.tops.GatheredSleeveShirtRedBrown.itemFabric}
      src={SS23.tops.GatheredSleeveShirtRedBrown.sizeChart}
      divId={SS23.tops.GatheredSleeveShirtRedBrown.shopifyDivId}
      mainId={SS23.tops.GatheredSleeveShirtRedBrown.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        SS23.tops.GatheredSleeveShirtRedBrown.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={SS23.tops.GatheredSleeveShirtRedBrown.itemName}
              width={SS23.imgWidth}
              height={SS23.imgHeight}
              loading={SS23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default GatheredSleeveShirtRedBrown;
